export default __webpack_public_path__ + "static/media/logo.00aefd60.png";